module.exports = "/_next/static/media/6c634c3bff61c2a5c292039f975c4071.svg";